export default "__VITE_ASSET__BXrpFDj___"